export default __webpack_public_path__ + "static/perpetua-io-ogimage-DE-a36073f0213a247cfd3a9cdc4d7251cb.png";